import { jsx as _jsx } from "react/jsx-runtime";
/** Pixels each circle slides over its predecessor: `overlap`, or ~30% of
 *  `size` by default. */
function circleStackSlide(size, overlap) {
    return overlap ?? Math.round(size * 0.3);
}
/** The laid-out width of a stack of `items` circles of `size` (0 when empty),
 *  for a caller that must know it before rendering, e.g. to choose how many
 *  fit. */
export function circleStackWidth(items, size, overlap) {
    return items === 0 ? 0 : size + (items - 1) * (size - circleStackSlide(size, overlap));
}
export function CircleStack({ items, renderItem, size = 26, overlap, gap = 2, max = 4, direction = 'left-on-top', }) {
    const slide = circleStackSlide(size, overlap);
    const visible = items.slice(0, max);
    const biteR = size / 2 + gap;
    const r = size / 2;
    // Bite center in the carved disc's coords: right→`(size-slide+r, r)`, left→`(slide-r, r)`.
    const biteCxRight = size - slide + r;
    const biteCxLeft = slide - r;
    return (_jsx("span", { style: { display: 'inline-flex' }, children: visible.map((item, i) => {
            const isFirst = i === 0;
            const isLast = i === visible.length - 1;
            const carveCx = direction === 'left-on-top'
                ? !isFirst
                    ? biteCxLeft
                    : null
                : !isLast
                    ? biteCxRight
                    : null;
            const carve = carveCx !== null
                ? `radial-gradient(circle at ${carveCx}px ${r}px, transparent ${biteR}px, black ${biteR + 0.5}px)`
                : undefined;
            const zIndex = direction === 'left-on-top' ? visible.length - i : i;
            return (_jsx("span", { style: {
                    position: 'relative',
                    zIndex,
                    width: size,
                    height: size,
                    marginLeft: i === 0 ? 0 : -slide,
                    borderRadius: 'var(--radius-full)',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    flexShrink: 0,
                    boxSizing: 'border-box',
                    ...(carve
                        ? { maskImage: carve, WebkitMaskImage: carve }
                        : {}),
                }, children: renderItem(item, i) }, i));
        }) }));
}
//# sourceMappingURL=CircleStack.js.map